import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { Subject, takeUntil } from 'rxjs';
import { OrderManagerService } from '../../services/order-manager/order-manager.service';

@Component({
  selector: 'lib-us-business-search-review',
  standalone: false,
  templateUrl: './us-business-search-review.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './us-business-search-review.component.css',
})
export class UsBusinessSearchReviewComponent implements OnInit, OnDestroy {
  order!: Order;

  private onDestroy$ = new Subject<void>();

  constructor(private orderManager: OrderManagerService
  ) { }

  ngOnInit(): void {
    this.orderManager.currentOrder
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(order => this.order = order);
  }

  ngOnDestroy(): void {
      // Signal all subscriptions to complete
      this.onDestroy$.next();
      this.onDestroy$.complete();
  }
}